import React from "react";
import { SafetyCertificateFilled, ShopFilled } from "@ant-design/icons";
import "Common/hooks/StyleFeatures/global.scss"
import { Chat, LibraryAddCheckOutlined } from "@mui/icons-material";
import AssignedTrainings from "PlatForms/OrgLMS/Dashboards/Mentor/AssignedTrainings/AssignedGroups";
import TrainingPage from "PlatForms/OrgLMS/Dashboards/Mentor/Projects/Projects";
import StartChat from "PlatForms/Dashboards/Chat/Chat";
import ChatBadge from "PlatForms/Dashboards/Chat/ChatBadges/ChatBadge";
import MentorDashboard from "PlatForms/OrgLMS/Dashboards/Mentor/LandingPage/MentorDashboard";
import Library from "PlatForms/OrgLMS/Dashboards/Mentor/Library/libraryCourses";
import TrainingCertificates from "PlatForms/OrgLMS/Dashboards/Learner/TrainingCertificate/TrainingCertificates";
import ProtectedPage from "Common/Components/ProtectedPage";



const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "mentor-dashboard",
    route: "/mentor-dashboard",
    icon: <ShopFilled size="12px" />,
    component: (
      <ProtectedPage navigateTo="/mentor-profile">
        <MentorDashboard />
      </ProtectedPage>
    ),
    
    noCollapse: true,
  },
  {
    type: "collapse",
    name: <ChatBadge dataKey="message" name="Messaging" unreadMessages={0}/>,
    key: "messaging",
    route: "/messaging",
    icon: <Chat size="12px" />,
    component: (
      <ProtectedPage navigateTo="/mentor-profile">
        <StartChat />
      </ProtectedPage>
    ),
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Assigned Groups",
    key: "assigned-groups",
    route: "/assigned-groups",
    icon: <LibraryAddCheckOutlined size="12px" />,
    component: (
      <ProtectedPage navigateTo="/mentor-profile">
        <AssignedTrainings />
      </ProtectedPage>
    ),
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Trainings",
    key: "project-training",
    route: "/project-training",
    icon: <LibraryAddCheckOutlined size="12px" />,
    component: (
      <ProtectedPage navigateTo="/mentor-profile">
        <TrainingPage />
      </ProtectedPage>
    ),
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Library",
    key: "library",
    route: "/library",
    icon: <LibraryAddCheckOutlined size="12px" />,
    component: (
      <ProtectedPage navigateTo="/mentor-profile">
        <Library />
      </ProtectedPage>
    ),
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Training Certificate",
    key: "training-certificate",
    route: "/training-certificate",
    icon: <SafetyCertificateFilled size="12px" />,
    component: (
      <ProtectedPage navigateTo="/mentor-profile">
        <TrainingCertificates />
      </ProtectedPage>
    ),
    noCollapse: true,
  },
];

export default routes;
